(function () {
  var TARGET_ID = 'pdp-weingut';
  var LINK_SELECTOR = 'a[href="#' + TARGET_ID + '"]';
  var ANCHOR_OFFSET_REM = 6;
  var SMOOTH_DURATION_MS = 800;

  function getScrollOffset() {
    var navbar = document.querySelector('.section_navbar');
    if (navbar) {
      return navbar.getBoundingClientRect().height;
    }
    return ANCHOR_OFFSET_REM * parseFloat(getComputedStyle(document.documentElement).fontSize);
  }

  function needsCorrection() {
    var section = document.querySelector('.section_weingut');
    if (!section) return false;
    return Math.abs(section.getBoundingClientRect().top - getScrollOffset()) > 24;
  }

  function scrollToWeingut(smooth) {
    var target = document.getElementById(TARGET_ID);
    var section = document.querySelector('.section_weingut');
    if (!target && !section) return false;

    var top;
    if (section) {
      top = section.getBoundingClientRect().top + window.scrollY - getScrollOffset();
    } else {
      top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset();
    }

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: smooth && !prefersReducedMotion ? 'smooth' : 'auto',
    });
    return true;
  }

  function correctIfNeeded(smooth) {
    if (needsCorrection()) {
      scrollToWeingut(smooth);
    }
  }

  function scheduleScroll(smooth) {
    scrollToWeingut(smooth);

    if (!smooth) {
      window.setTimeout(function () {
        correctIfNeeded(false);
      }, 500);
      window.setTimeout(function () {
        correctIfNeeded(false);
      }, 1500);
      return;
    }

    window.setTimeout(function () {
      correctIfNeeded(true);
    }, SMOOTH_DURATION_MS + 200);
    window.setTimeout(function () {
      correctIfNeeded(true);
    }, 1500);
  }

  function watchLayoutShift() {
    var slider = document.getElementById('product-hero-winery-slider');
    if (!slider || !window.ResizeObserver) return;

    var timer;
    new ResizeObserver(function () {
      if (window.location.hash !== '#' + TARGET_ID) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        correctIfNeeded(true);
      }, 100);
    }).observe(slider);
  }

  function isSamePageLink(link) {
    return link.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest(LINK_SELECTOR);
      if (!link || !isSamePageLink(link)) return;
      if (!document.getElementById(TARGET_ID) && !document.querySelector('.section_weingut')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', '#' + TARGET_ID);
      }

      scheduleScroll(true);
    },
    true
  );

  watchLayoutShift();

  if (window.location.hash === '#' + TARGET_ID) {
    var runOnLoad = function () {
      scheduleScroll(false);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runOnLoad);
    } else {
      runOnLoad();
    }
  }
})();
